import { apiGet, apiPost, apiPatch, apiDelete, makeRequestsDict } from '@/app/api/core/http';
import modules from 'App/utils/Modules';
import { CAT_COMPANIES, CAT_CONTACTS, CAT_FEATURES, CAT_FEATURE_OPTIONS } from 'App/utils/Collections';
import { TAXONOMY_PATHS } from './paths';

export const taxonomyApiAdapter = {
  types: {
    create: (data) => {
      return apiPost(TAXONOMY_PATHS.types, { data });
    },
    getList: (params) =>
      apiGet(TAXONOMY_PATHS.types, {
        params,
        headers: { Accept: 'application/ld+json' },
      }),
    getItem: (id, params) => apiGet(`${TAXONOMY_PATHS.types}/${id}`, { params }),
    update: (id, data) => {
      return apiPatch(`${TAXONOMY_PATHS.types}/${id}`, { data });
    },
    remove: (id) => apiDelete(`${TAXONOMY_PATHS.types}/${id}`),
    getChildTypesByBrandId: (typeId, brandId, params = {}) =>
      apiGet(`${TAXONOMY_PATHS.types}/${typeId}/brand/${brandId}/child-types`, { params }),
  },
  categories: {
    getList: (params) => apiGet(TAXONOMY_PATHS.categories, { params }),
    getReadable: (params) => apiGet(`${TAXONOMY_PATHS.categories}/readable_by_me`, { params }),
    getWritable: (params) => apiGet(`${TAXONOMY_PATHS.categories}/writable_by_me`, { params }),
  },
  additionalFieldNames: {
    getList: (params) => apiGet(TAXONOMY_PATHS.additionalFieldNames, { params }),
  },
  activitySpheres: {
    getList: (params) => apiGet(TAXONOMY_PATHS.activitySpheres, { params }),
    getItem: (id, params) => apiGet(`${TAXONOMY_PATHS.activitySpheres}/${id}`, { params }),
    create: (data) => apiPost(TAXONOMY_PATHS.activitySpheres, { data }),
    update: (id, data) => apiPatch(`${TAXONOMY_PATHS.activitySpheres}/${id}`, { data }),
    delete: (id) => apiDelete(`${TAXONOMY_PATHS.activitySpheres}/${id}`),
  },
  featureGroups: {
    getList: (params) => apiGet(TAXONOMY_PATHS.featureGroups, { params }),
    // Hydra response with totals for paginated tables; getList callers rely on a plain array.
    getHydraList: (params) => apiGet(TAXONOMY_PATHS.featureGroups + TAXONOMY_PATHS.suffix, { params }),
    getItem: (id, params) => apiGet(`${TAXONOMY_PATHS.featureGroups}/${id}`, { params }),
    create: (data) => apiPost(TAXONOMY_PATHS.featureGroups, { data }),
    update: (id, data) => apiPatch(`${TAXONOMY_PATHS.featureGroups}/${id}`, { data }),
    remove: (id) => apiDelete(`${TAXONOMY_PATHS.featureGroups}/${id}`),
  },
  [CAT_FEATURES]: makeRequestsDict(TAXONOMY_PATHS.features),
  [CAT_FEATURE_OPTIONS]: makeRequestsDict(TAXONOMY_PATHS.featureOptions),
  getModules: (params) => apiGet(TAXONOMY_PATHS.modules, { params }),
  getFeatureHistory: (id, params) => apiGet(`${TAXONOMY_PATHS.features}/${id}/history`, { params }),
  getFeatureSnapshotById: (id, snapshot_id) =>
    apiGet(`${TAXONOMY_PATHS.features}/${id}/history/snapshots/${snapshot_id}`),
  getFeatureOptionsHistory: (id) => apiGet(`${TAXONOMY_PATHS.featureOptions}/${id}/history`),
  getFeatureOptionsSnapshotById: (id, snapshot_id) =>
    apiGet(`${TAXONOMY_PATHS.featureOptions}/${id}/history/snapshots/${snapshot_id}`),
};

export const taxonomyFilterAdapter = {
  getProductTypes: (params) => apiGet(TAXONOMY_PATHS.types, { params: { ...params } }),
  getCompanyTypes: (params) => apiGet(TAXONOMY_PATHS.types, { params: { ...params, modules: modules[CAT_COMPANIES] } }),
  getContactTypes: (params) => apiGet(TAXONOMY_PATHS.types, { params: { ...params, modules: modules[CAT_CONTACTS] } }),
  getProductFeatures: (params) => apiGet(TAXONOMY_PATHS.features + TAXONOMY_PATHS.suffix, params),
  getProductFeature: (id, params) => apiGet(`${TAXONOMY_PATHS.features}/${id}`, { params }),
};
